import proptypes from 'prop-types';

const { bool, string } = proptypes;

export const CollectionPropTypes = {
  collectionId: string.isRequired,
  preview: bool
};

export const CollectionDefaultProps = {
  preview: false
};
